import { NgModule } from '@angular/core';
import { NgxMaskModule } from 'ngx-mask';
import { RouterModule } from '@angular/router';
import { SharedModule } from '../../../../../core/modules/shared.module';


import { RegisterationComponent } from './registeration.component';
import { RegisterationFormComponent } from './register-form/register-form.component';

/**Service file */
import { AuthService } from '../auth.service';

//Query file
import { UserQueryService, RolesQueryService } from '../../gql-query-mutation/index';


const routes = [
    {
        path: 'registration',
        component: RegisterationComponent,
        resolve: {
            auth: AuthService,
        }
    }
];

@NgModule({
    declarations: [
        RegisterationComponent,
        RegisterationFormComponent
    ],
    imports: [
        SharedModule,
        RouterModule.forChild(routes),
        NgxMaskModule.forRoot()
    ],
    providers: [
        /**Service file */
        AuthService,
        //Query file
        UserQueryService,
        RolesQueryService
    ],
})

export class RegisterationModule {

}



// WEBPACK FOOTER //
// E:/NeoSME/1.Full Project Spekwo/pro/prodash/src/app/main/content/apps/authentication/registration/registeration.module.ts